import { useEffect } from 'react'
import { observer, useLocalObservable } from 'mobx-react'
import { TreePage, Card, Scrollbars } from 'src/components'
import { Header } from './components'
import { layoutStore } from 'enasops/stores'
import { $api } from 'src/plugins'
import { extendRules, getSingleRule, initFilter } from 'src/utils/common'
import 'enasops/styles/op/140/index.less'

type Industry = {
  Id: string,
  Code: string,
  Name: string,
  Type: number
}

export type State = {
  active?: Industry,
  setActive: (data?: Industry) => void,
  industry: Industry[],
  setIndustry: (data: Industry[]) => void,
  getIndustry: (resetActive?: boolean) => void,
  formData: any
}

const OP140 = observer(() => {
  const state = useLocalObservable<State>(() => {
    return {
      active: undefined,
      setActive (data) {
        this.active = data
      },
      industry: [],
      setIndustry (data) {
        this.industry = data
      },
      getIndustry (resetActive) {
        $api['op140/getEquipmentTypeIndustry']().then(res => {
          if (res?.length) {
            resetActive && this.setActive(res[0])
            this.setIndustry(res)
          }
        })
      },
      get formData (): any {
        const payload = initFilter({})
        extendRules(payload, [getSingleRule('INDUSTRY_ID', 1, this.active?.Id ?? '')])
        return {
          filterGroup: payload.FilterGroup,
          extraSaveData: { INDUSTRY_ID: this.active?.Id ?? '' }
        }
      }
    }
  })
  useEffect(() => { state.getIndustry(true) }, [])

  useEffect(() => {
    layoutStore.setSlot(<Header />, { state })

    return () => {
      layoutStore.removeSlot()
    }
  }, [])

  return (
    <div className='op140'>
      <div className='op140__header'>
        <Card className='op140__card'>
          <p>领域行业</p>
          <div className='op140__scroll'>
            <Scrollbars>
              <div className='op140__industry'>
                {
                  state.industry.map(item => {
                    return (
                      <div
                        key={item.Id}
                        onClick={() => state.setActive(item)}
                        className={item.Id === state.active?.Id ? 'active' : ''}
                      >
                        <p>{item.Name}</p>
                        <p>{item.Code}</p>
                      </div>
                    )
                  })
                }
              </div>
            </Scrollbars>
          </div>
        </Card>
      </div>
      <div className='full-parent'>
        {
          state.active?.Id
            ? (
              <TreePage
                key={state.active.Id}
                formCode='OP102'
                formData={state.formData}
              />
            )
            : null
        }
      </div>
    </div>
  )
})

export default OP140